import { useQuery } from "react-query";
import { getTaskContextByKey } from "components/task-list/lib/taskData";

export const useShipmentUpcs = (shipmentKey) => {
    return useQuery({
        queryKey: ["upcs", shipmentKey],
        queryFn: () => getTaskContextByKey(shipmentKey),
    });
};
